export default __webpack_public_path__ + "assets/models/85f8fada2d523e68d84746eeb983b9b7.glb";